module.exports = __webpack_public_path__ + "static/media/Pattern12.05bdb165.png";